import cricketsports1 from "../images/cricket_sports/cricketsports1.png";
import '../invitations/Invitation.css'

const cricketsportsInvitationElements = [

  // 🏏 TOP ICONS
  {
    id: 1,
    type: "text",
    text: "🏏",
    x: 250,
    y: 200,
    fontSize: 25,
    fontFamily: "Poppins",
    fill: "#16a34a" // green
  },

  {
    id: 2,
    type: "text",
    text: "🏏",
    x: 480,
    y: 200,
    fontSize: 25,
    fontFamily: "Poppins",
    fill: "#16a34a"
  },

  // ✨ TOP DIVIDER
  {
    id: 3,
    type: "text",
    text: "✦ ✦ ✦",
    x: 350,
    y: 200,
    fontSize: 18,
    fontFamily: "Poppins",
    fill: "#16a34a" // gold
  },

  // 🏆 TITLE
  {
    id: 4,
    type: "text",
    text: "Cricket Tournament",
    x: 250,
    y: 230,
    fontSize: 30,
    fontFamily: "Playfair Display",
    fill: "#065f46"
  },

  // ✨ SUBTITLE
  {
    id: 5,
    type: "text",
    text: "You're Invited!",
    x: 320,
    y: 270,
    fontSize: 30,
    fontFamily: "Great Vibes",
    fill: "#16a34a"
  },

  // ✨ LINE
  {
    id: 6,
    type: "text",
    text: "──────── ✦ ────────",
    x: 280,
    y: 300,
    fontSize: 20,
    fontFamily: "Poppins",
    fill: "#16a34a"
  },

  // 🏏 EVENT NAME
  {
    id: 7,
    type: "text",
    text: "Annual Cricket League 2026",
    x: 250,
    y: 320,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#064e3b"
  },

  // 📢 INVITE TEXT
  {
    id: 8,
    type: "text",
    text: "Join us for an exciting day of क्रिकेट action,",
    x: 250,
    y: 350,
    fontSize: 15,
    fontFamily: "Poppins",
    fill: "#050506"
  },

  {
    id: 9,
    type: "text",
    text: "team spirit, and unforgettable moments!",
    x: 275,
    y: 380,
    fontSize: 13,
    fontFamily: "Poppins",
    fill: "#050506"
  },

  // 📅 DATE
  {
    id: 10,
    type: "text",
    text: "🗓 Sunday, 22 March 2026",
    x: 260,
    y: 450,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#050506"
  },

  // ⏰ TIME
  {
    id: 11,
    type: "text",
    text: "⏱ 8:00 AM onwards",
    x: 280,
    y: 490,
    fontSize: 22,
    fontFamily: "Poppins",
    fill: "#050506"
  },

  // 📍 VENUE TITLE
  {
    id: 12,
    type: "text",
    text: "Venue",
    x: 350,
    y: 540,
    fontSize: 28,
    fontFamily: "Playfair Display",
    fill: "#065f46"
  },

  // 📍 VENUE NAME
  {
    id: 13,
    type: "text",
    text: "City Cricket Ground,",
    x: 280,
    y: 580,
    fontSize: 26,
    fontFamily: "Poppins",
    fill: "#334155"
  },

  {
    id: 14,
    type: "text",
    text: "Vijayawada",
    x: 340,
    y: 610,
    fontSize: 24,
    fontFamily: "Poppins",
    fill: "#334155"
  },

  // 🎉 FOOTER
  {
    id: 15,
    type: "text",
    text: "Come cheer, play & celebrate the spirit of cricket! 🎉",
    x: 230,
    y: 680,
    fontSize: 22,
    fontFamily: "Great Vibes",
    fill: "#065f46"
  },

  // 🏆 FINAL LINE
  {
    id: 16,
    type: "text",
    text: "🏆 Let the Game Begin! 🏆",
    x: 220,
    y: 730,
    fontSize: 28,
    fontFamily: "Playfair Display",
    fill: "#043829"
  },

  // BACKGROUND IMAGE
  {
    id: 17,
    type: "background",
    src: cricketsports1,
    x: 0,
    y: 0,
    width: 595,
    height: 842
  }

];

export default cricketsportsInvitationElements;